/**
 * Created by Henry Huang on 2018/7/10.
 */
export const minZero = (raw: number): number => raw <= 0 ? 0 : raw;

export const fix2 = (raw: number): number => Math.round(raw * 100) / 100;

export const minZeroFix2 = (raw: number): number => minZero(fix2(raw));
